import React from 'react';
import PropTypes from 'prop-types';
import './style';

const PublicationItem = (props, context) => {
  const { theme: { colorPrimary, textAlternate } } = context;

  function underlineMe(str) {
    var splited = str.split('Jeongseok Son');
    return [splited[0], <u key="1">Jeongseok Son</u>, splited[1]];
  }

  return (
    <div
      className="publication-item"
      style={{ backgroundColor: colorPrimary, color: textAlternate }}
    >
      <div className="publication-item__title">{props.title}</div>

      <div className="publication-item__authors">
        {underlineMe(props.authors)}
      </div>
      <div className="publication-item__venue">
        {props.venue}
      </div>
      <div className="publication-item__icon">
        {props.icons.map((icon, i) => (
          <a target="_blank" rel="noopener noreferrer" href={icon.url} key={i}><i className={icon.icon}></i></a>
        ))}
      </div>
    </div>
  );
};

PublicationItem.contextTypes = {
  theme: PropTypes.any
};

export default PublicationItem;



// WEBPACK FOOTER //
// ./src/components/PublicationItem/PublicationItem.js